import React, { memo } from "react";
import RequestImageGallery from "./RequestImageGallery";
import { formatMoney } from "../../../utils";

const ExtraMaterials = memo(({ material }) => (
    <div className="card mb-3">
        <div className="card-body pb-0">
            <h6 className="mb-1 text-gradient text-dark">Requested Extra Materials</h6>
            <h6 className="mb-1 text-gradient text-dark mt-2">Materials</h6>
            <p className="text-sm text-dark mb-1 mt-2" style={{ fontWeight: "normal" }}>Description</p>
            <p className="text-sm my-auto text-dark">
                {material.request_material_description}
            </p>

            <p className="mt-0 text-sm">
                <RequestImageGallery 
                    images={material?.request_material_images.map((image) => ({ftm_request_image_path: image.request_material_image_path}))} 
                />
            </p>

            <h6 className="mb-1 text-gradient text-dark mt-3 mb-0">Cost</h6>
            <div className="card card-plain mb-3">
                <div className="container">
                    <div className="row">
                        <div className="col-sm">
                            <div className="text-start">
                                <h6 className="mb-0 text-sm font-weight">Quantity</h6>
                                <p className="mb-0 text-sm">{material.request_material_qty}</p>
                            </div>
                        </div>
                        <div className="col-sm">
                            <div className="text-center">
                                <h6 className="mb-0 text-sm font-weight">Unit Price</h6>
                                <p className="mb-0 text-sm">{formatMoney(material.request_material_unit_price)}</p>
                            </div>
                        </div>
                        <div className="col-sm">
                            <div className="text-end">
                                <h6 className="mb-0 text-sm font-weight">Net Price</h6>
                                <p className="mb-0 text-sm">{formatMoney(material.request_material_net_price)}</p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
));

export default ExtraMaterials;